import React, { useState, useEffect, useCallback } from "react";
import Menu from "../../../../components/layout/menu/index";
import 'simplebar-react/dist/simplebar.min.css';
import UploadDocumentButton from "../../../../components/shared/uploadDocument";
import UploadDocument from "../../../../components/shared/modals/modalDocument/uploadDocument";
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import ModalUploadWithSelect from "../../../../components/shared/modals/modalUploadWithSelect";
import { useAuth } from '../../../../context/auth';
import {  uploadSdsFile, downloadSupplierFiles} from '../../../../client/seasonDocumentSuppliers';
import {  getSeasonsPerSupplier } from "../../../../client/seasons/index";
import { getDocumentsBySupplierSeason } from "../../../../client/seasonDocumentSuppliers/index";
import SelectField from "../../../../components/forms/selectOption/index";
import RequirementsFilters from "../../../../components/filters/requirementsFilters";
import ResetFilters from "../../../../components/filters/resetFilters";
import FilterInput from "../../../../components/filters/filterInput";
import ContentLoader from "react-content-loader";
import { useModuleAdherence } from "../../../../hooks/userAdherence";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";

const statusColors = {
  Pendiente: '#FFB81C',
  Aprobado: '#43B02A',
  Subido: '#00A3E0',
  Rechazado: '#E44949'
};

export default function Requirements() {
  useModuleAdherence(14);

  const { supplierId, supplierName } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [showModalUploadDocument, setShowModalUploadDocument] = useState(false);
  const [showModalFormDocument, setShowModalFormDocument] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showUploadSuccessWithSelect, setShowUploadSuccessWithSelect] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [documentFilters, setDocumentFilters] = useState([]);
  const [resetFiltersFlag, setResetFiltersFlag] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [seasonName, setSeasonName] = useState("");

  const [rows, setRows] = useState([]);
  const [docOptions, setDocOptions] = useState([]);

  const [seasonId, setSeasonId] = useState(null);
  const [seasons, setSeasons] = useState([]);
  const [noSeasonsAssigned, setNoSeasonsAssigned] = useState(false);

  const [initialLoading, setInitialLoading] = useState(true); 
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

const handleDownloadDocument = async (documentId, documentName, sdsId, fileIds = []) => {
  if (!supplierId || !seasonId || !documentId) {
    setAlertMessage("No hay temporada, proveedor o documento seleccionado");
    setShowAlertModal(true);
    return;
  }

  try {
    if (fileIds && fileIds.length > 0) {
      await downloadSupplierFiles(seasonId, supplierId, fileIds, documentId);
    } else {

      await downloadSupplierFiles(seasonId, supplierId, undefined, documentId);
    }
} catch (error) {
  console.error("Error descargando archivos del documento:", error);
  
    const errorMessage = error.message || `Error al descargar archivos de "${documentName}"`;
    
    setAlertMessage(errorMessage);
    setShowAlertModal(true);
}
};

  const openUploadFlow = () => {
    setShowUploadSuccessWithSelect(true);
  }

  const openFormModal = () => {
    setShowModalFormDocument(true);
  }

  const closeSuccessModal = () => {
    setShowModalSuccess(false);
  }

  const tableConfig = {
    headers: ['#', 'Documentación', 'Estado', 'Fecha de envío', 'Fecha de respuesta','Descargar'],
    accessors: ['id', 'documentation', 'estado', 'fechaEnvio', 'fechaRespuesta', 'descargar'],
    widths: ['46px', '260px', '114px', '112px', '112px', '90px']
  };

  const statusLabelFromCode = (code) => {
    switch (code) {
      case 1: return 'Pendiente';
      case 2: return 'Subido';
      case 3: return 'Aprobado';
      case 4: return 'Rechazado';
      default: return 'Pendiente';
    }
  };

  const loadDocumentsWithFilters = useCallback(async () => {
    if (!supplierId || !seasonId) {
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const params = {};
      
      if (documentFilters.length > 0) {
        params.documentIds = documentFilters.map(id => Number(id));
      }
      
      if (searchTerm.trim() !== "") {
        params.search = searchTerm.trim();
      }


      const response = await getDocumentsBySupplierSeason(
        Number(supplierId), 
        seasonId, 
        params
      );
      const result = response.data.data;
      
      
      setSeasonName(result.season_name || "");


      const filteredRows = result.documents.map((doc, index) => {
        const hasFiles = doc.sended_at != null;
        const status = statusLabelFromCode(doc.status);
        const canDownload = hasFiles && doc.status !== 1; // Pendiente = 1

        const fileIds = doc.files ? doc.files.map(file => file.id) : [];

        return {
          id: index + 1,
          documentation: doc.document_name,
          estado: status,
          fechaEnvio: doc.sended_at ? fmtDateTimeLima(doc.sended_at) : "—",
          fechaRespuesta: doc.answered_at ? fmtDateTimeLima(doc.answered_at) : "—",
          descargar: () => handleDownloadDocument(
            doc.document_id, 
            doc.document_name, 
            doc.sds_id,
            fileIds  
          ),
          document_id: doc.document_id,
          sds_id: doc.sds_id,
          hasFiles: hasFiles,
          status: doc.status,
          canDownload: canDownload,
          fileIds:fileIds
        };
      });

      setRows(filteredRows);

      const uploadableDocs = result.documents
        .filter(doc => doc.status === 1 || doc.status === 4) // Pendiente o Rechazado
        .map(doc => ({
          value: String(doc.sds_id),
          label: doc.document_name,
          multiple: doc.multiple,
          perPlant: doc.perPlant,
          status: doc.status,
          sds_id: doc.sds_id, 
        }));


      setDocOptions(uploadableDocs);

    } catch (e) {
      console.error('❌ ERROR cargando documentos con filtros:', e);
      console.error('   Response:', e.response);
      console.error('   Status:', e.response?.status);
      
      if (e?.response?.status === 404) {
        setSeasonName("");
        setDocOptions([]);
        setRows([]);
        setError(e?.response?.data?.message || "No hay documentos para la temporada seleccionada.");
      } else if (e?.response?.status === 500) {
        setError("Error interno del servidor. Por favor, intente más tarde.");
      } else {
        setError(e?.response?.data?.message || "No se pudo cargar los documentos.");
      }
    } finally {
      setLoading(false);
      setHasLoadedOnce(true);
    }
  }, [supplierId, seasonId, documentFilters, searchTerm]);

  const loadSupplierDocs = useCallback(async (selectedSeasonId = null) => {
    if (!supplierId) return;

    try {
      setLoading(true);
      setError(null);

      const seasonToUse = selectedSeasonId !== null ? selectedSeasonId : seasonId;
      
      if (!seasonToUse) {
        setError("Por favor seleccione una temporada.");
        setLoading(false);
        return;
      }
      
      const res = await getDocumentsBySupplierSeason(Number(supplierId), seasonToUse);
      const body = res.data.data;
      
      setSeasonName(body.name ?? "");

      const filteredDocs = (body.documents ?? [])
        .filter(d => d.status === 1 || d.status === 4);

      setDocOptions(
        filteredDocs.map(d => ({
          value: String(d.sds_id),
          label: d.document_name,
          multiple: !!d.multiple,
          perPlant: !!d.perPlant,
          status: d.status, 
          sds_id: d.sds_id,
        }))
      );

      setRows(
        (body.documents ?? []).map((d, idx) => {
            const fileIds = d.files ? d.files.map(file => file.id) : [];
          return {
          id: idx + 1,
          documentation: d.document_name,
          estado: statusLabelFromCode(d.status),
          fechaEnvio: fmtDateTimeLima(d.sended_at),
          fechaRespuesta: fmtDateTimeLima(d.answered_at),
          descargar: () => handleDownloadDocument(
            d.document_id, 
            d.document_name, 
            d.sds_id,
            fileIds  
          ),
          document_id: d.document_id,
          sds_id: d.sds_id,
          hasFiles: d.has_files || false,
          fileIds: fileIds
        };
      })
      );
    } catch (e) {
      console.error('❌ ERROR cargando documentos:', e);
      if (e?.response?.status === 404) {
        setSeasonName("");
        setDocOptions([]);
        setRows([]);
        setError("No hay documentos para la temporada seleccionada.");
      } else {
        setError(e?.response?.data?.message || "No se pudo cargar los documentos.");
      }
    } finally {
      setLoading(false);
    }
  }, [supplierId, seasonId]);

  const toUtcDate = (v) => {
    if (!v) return null;
    if (v instanceof Date) return v;
    if (typeof v === "number") return new Date(v);

    if (typeof v === "string") {
      let s = v.trim();

      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        return new Date(s + "T00:00:00Z");
      }

      const hasTZ = /[zZ]|[+\-]\d{2}:\d{2}$/.test(s);
      if (!hasTZ && /^\d{4}-\d{2}-\d{2}T/.test(s)) {
        s += "Z";
      }

      return new Date(s);
    }

    return new Date(v);
  };

  const fmtDateTimeLima = (value, fallback = "—") => {
    const d = toUtcDate(value);
    if (!d || isNaN(+d)) return fallback;

    return new Intl.DateTimeFormat("es-PE", {
      timeZone: "America/Lima",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(d);
  };

  useEffect(() => {
    if (supplierId) {
      setInitialLoading(true);
      loadSupplierSeasons(supplierId);
    } else {
      setLoading(false);
      setInitialLoading(false);
    }
  }, [supplierId]); 

  const loadSupplierSeasons = async (supplierId) => {
    try {
      const response = await getSeasonsPerSupplier(supplierId);
      const seasonsData = response.data.seasons || [];
      const enabledSeasons = seasonsData.filter(season => season.enable === true);
      setSeasons(enabledSeasons);

      if (enabledSeasons.length === 0) {
        setNoSeasonsAssigned(true);
        setSeasonId(null);
        setSeasonName("");
      } else {
        setNoSeasonsAssigned(false);
        if (!seasonId) {
          const firstSeasonId = enabledSeasons[0].id;
          setSeasonId(firstSeasonId);
        }
      }
    } catch (error) {
      console.error('Error cargando temporadas:', error);
      setSeasons([]);
      setNoSeasonsAssigned(true);
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    if (supplierId && seasonId && !noSeasonsAssigned) {

      const timer = setTimeout(() => {
        loadDocumentsWithFilters();
      }, 300);

      return () => clearTimeout(timer);
    } else if (noSeasonsAssigned) {
    
      setRows([]);
      setDocOptions([]);
      setError(null);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [seasonId, supplierId, documentFilters, searchTerm, loadDocumentsWithFilters, noSeasonsAssigned]);

  const handleSeasonChange = (e) => {
    const newSeasonId = Number(e.target.value);
    setSeasonId(newSeasonId);
    resetAllFilters();
  };

  const handleApplyFilters = (filters) => {
    setDocumentFilters(filters.documentIds || []);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const resetAllFilters = () => {
    setSearchTerm("");
    setDocumentFilters([]);
    setResetFiltersFlag(prev => !prev); 
  };

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="pt-4 pb-10 px-[5%] sm:px-[3%] flex flex-col gap-4">
          {initialLoading ? (
            <div className="flex flex-col items-start justify-between gap-4 md:flex-row">
              <ContentLoader 
                speed={2}
                width={400}
                height={40}
                viewBox="0 0 400 40"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
              >
                <rect x="0" y="0" rx="4" ry="4" width="300" height="40" />
              </ContentLoader>
              <ContentLoader 
                speed={2}
                width={200}
                height={40}
                viewBox="0 0 200 40"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
              >
                <rect x="0" y="0" rx="4" ry="4" width="200" height="40" />
              </ContentLoader>
            </div>
          ) : (
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row">
            <h1 className="text-blue font-itcbold text-[5.33vw] sm:text-[4.33vw] md:text-[3.33vw] lg:text-[2.33vw]">
              Requisitos de Inicio de Temporada
            </h1>
            {!noSeasonsAssigned && (
            <div className="flex flex-col items-start gap-3 sm:flex-row">
              <UploadDocumentButton
                  onClick={openUploadFlow}
                  isEnabled={true}
              />
              <SelectField
                title="Temporada:"
                name="temporadas"
                value={seasonId ?? ""}
                onChange={handleSeasonChange}
                options={seasons.map(s => ({
                  value: s.id,
                  label: s.name
                }))}
                placeholder="Seleccione una temporada"
                width="w-[200px]"
                bgColor="bg-white"
                border="border-slate-300"
              />
            </div>
            )}

          </div>
          )}
          
          {initialLoading ? (
            <ContentLoader 
              speed={2}
              width={300}
              height={30}
              viewBox="0 0 300 30"
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
            >
              <rect x="0" y="0" rx="4" ry="4" width="250" height="30" />
            </ContentLoader>
          ) : (
          <h2 className="font-itcbook text-[#6B7280] text-[4.7vw] sm:text-[3.7vw] md:text-[2.7vw] lg:text-[1.7vw] ">
            Estimado proveedor, {supplierName || ""}
          </h2>
          )}
          
          {initialLoading ? (
            <>
            <ContentLoader 
              speed={2}
              width="100%"
              height={80}
              viewBox="0 0 1000 80"
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
            >
              <rect x="0" y="0" rx="4" ry="4" width="100%" height="20" />
              <rect x="0" y="30" rx="4" ry="4" width="90%" height="20" />
              <rect x="0" y="60" rx="4" ry="4" width="80%" height="20" />
            </ContentLoader>

            <div className="flex flex-col justify-end w-full gap-2 sm:flex-row">
              <ContentLoader 
                speed={2}
                width={200}
                height={40}
                viewBox="0 0 200 40"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
              >
                <rect x="0" y="0" rx="4" ry="4" width="200" height="40" />
              </ContentLoader>
              <ContentLoader 
                speed={2}
                width={100}
                height={40}
                viewBox="0 0 100 40"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
              >
                <rect x="0" y="0" rx="4" ry="4" width="100" height="40" />
              </ContentLoader>
            </div>
            </>
          ) : (
            <>
              {noSeasonsAssigned ? (
                <div className="p-6 text-center ">
                  <p className="mb-4 text-lg text-red font-itcbook">
                    Aún no se le ha asignado una temporada.
                  </p>

                </div>
              ) : (
                <>
              <p className="text-[#2F2F3B] font-itcbook text-[4.16vw] sm:text-[3.16vw] md:text-[2.16vw] lg:text-[1.16vw]">
                Con el fin de asegurar y cumplir con todos los requerimientos sanitarios y de seguridad,
                se detalla los puntos necesarios para que puedan abordar las embarcaciones en la bahía y/o
                plantas correspondientes.
              </p>

          <div className="flex flex-col justify-end w-full gap-2 sm:flex-row">
            <FilterInput
              placeholder="Buscar documentos"
               value={searchTerm}
              onChange={handleSearchChange}
            />
            <div className="flex gap-2 ">
            <RequirementsFilters
              applyFilters={handleApplyFilters}
              resetFlag={resetFiltersFlag}
              seasonId={seasonId}
              supplierId={supplierId}
            />
            <ResetFilters
              borderColor="border-blue-light"
              textColor="text-[#6B7280]"
              font="font-itcbook"
              onClick={resetAllFilters}
            />
            </div>
          </div>
              </>
             )}
            </>
          )}


          {initialLoading ? (
            <div className="w-full">
              <ContentLoader 
                speed={2}
                width="100%"
                height={400}
                viewBox="0 0 1000 400"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
              >
                {/* Cabecera de la tabla */}
                <rect x="0" y="0" rx="4" ry="4" width="100%" height="50" />
                {/* Filas */}
                <rect x="0" y="60" rx="4" ry="4" width="100%" height="40" />
                <rect x="0" y="110" rx="4" ry="4" width="100%" height="40" />
                <rect x="0" y="160" rx="4" ry="4" width="100%" height="40" />
                <rect x="0" y="210" rx="4" ry="4" width="100%" height="40" />
                <rect x="0" y="260" rx="4" ry="4" width="100%" height="40" />
              </ContentLoader>
            </div>
          ) : (
          <>
            {!hasLoadedOnce && loading && (
              <div className="w-full">
                <ContentLoader 
                    speed={2}
                    width="100%"
                    height={400}
                    viewBox="0 0 1000 400"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="4" ry="4" width="100%" height="50" />
                    <rect x="0" y="60" rx="4" ry="4" width="100%" height="40" />
                    <rect x="0" y="110" rx="4" ry="4" width="100%" height="40" />
                    <rect x="0" y="160" rx="4" ry="4" width="100%" height="40" />
                    <rect x="0" y="210" rx="4" ry="4" width="100%" height="40" />
                    <rect x="0" y="260" rx="4" ry="4" width="100%" height="40" />
                  </ContentLoader>
              </div>
            )}

            {hasLoadedOnce && loading && (
                <div className="w-full">
                  <ContentLoader 
                    speed={2}
                    width="100%"
                    height={400}
                    viewBox="0 0 1000 400"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="100%" height="50" />
                    <rect x="0" y="60" rx="4" ry="4" width="100%" height="40" />
                    <rect x="0" y="110" rx="4" ry="4" width="100%" height="40" />
                    <rect x="0" y="160" rx="4" ry="4" width="100%" height="40" />
                    <rect x="0" y="210" rx="4" ry="4" width="100%" height="40" />
                    <rect x="0" y="260" rx="4" ry="4" width="100%" height="40" />
                  </ContentLoader>
                </div>
            )}

            {error && (
              <div className="px-4 py-3 text-sm border rounded-xl border-amber-200 bg-amber-50 text-amber-800">
                {error}
              </div>
            )}

            {!loading && !error && rows.length > 0 && (
            <DynamicTable
              data={rows}
              config={tableConfig}
              showPagination={false}
              statusColors={statusColors}
            />
            )}
            
            {!loading && !error && rows.length === 0 && hasLoadedOnce && (
            <div className="px-4 py-3 text-sm text-gray-600 bg-white border border-gray-200 rounded-xl">
              No se encontraron documentos para esta temporada.
            </div>
            )}
          </>
          )}
        </div>
      </div>
      <UploadDocument
        showModalUploadDocument={showModalUploadDocument}
        closeModal={() => setShowModalUploadDocument(false)}
        openModal={openFormModal}
        onFileProcessed={(file) => {
          setShowModalUploadDocument(false);
          setSelectedFiles(file ? [file] : []);
          setShowUploadSuccessWithSelect(true);
        }}
        acceptFiles={"*"}
        proccessFile={false}
        multiple={true}
      />
      <ModalSuccess
        showModalSuccess={showModalSuccess}
        closeModalSuccess={closeSuccessModal}
        fill="green"
        text="¡Su documento ha sido enviado con éxito!"
      />
      <ModalUploadWithSelect
        open={showUploadSuccessWithSelect}
        onClose={() => {
          setShowUploadSuccessWithSelect(false);
        }}
        text="Selecciona a qué documento pertenece el/los archivo(s)"
        options={docOptions}
        filesCount={selectedFiles[0]?.length || 0}
        seasonId={seasonId} 
        supplierId={supplierId} 
        onSubmit={async ({ sdsId, centerId, files, fileNames }) => { 

          try {
            const result = await uploadSdsFile({ 
              sdsId: Number(sdsId), 
              centerId: centerId ? Number(centerId) : undefined,
              files: files || [],
              fileNames: fileNames || []
            });
            
            
            setShowUploadSuccessWithSelect(false);
            await loadSupplierDocs();
            setShowModalSuccess(true);
          } catch (error) {
            console.error('❌ Error subiendo archivos:', error);
            throw error;
          }
        }}
      />

      <ModalAlertWarning
        showModalAlertWarning={showAlertModal}
        closeModal={() => setShowAlertModal(false)}
        error={alertMessage}
      />
    </div>
  );
}
